import { render, staticRenderFns } from "./statistical-analysis-view-detail-table.vue?vue&type=template&id=49c6b990&scoped=true&"
import script from "./statistical-analysis-view-detail-table.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-view-detail-table.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-view-detail-table.scss?vue&type=style&index=0&id=49c6b990&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c6b990",
  null
  
)

export default component.exports